export var addressFields = [
    'addressLine1',
    'addressLine2',
    'addressLine3',
    'postTown',
    'county',
    'country',
    'postcode',
    'countryId',
];
export var cardType;
(function (cardType) {
    cardType["actuary"] = "actuary";
    cardType["employer"] = "employer";
    cardType["inHouseAdmin"] = "inHouseAdmin";
    cardType["insurer"] = "insurer";
    cardType["thirdParty"] = "thirdParty";
    cardType["trustee"] = "trustee";
    cardType["corporateGroup"] = "corporateGroup";
    cardType["independent"] = "independent";
})(cardType || (cardType = {}));
export var cardTypeName;
(function (cardTypeName) {
    cardTypeName["actuary"] = "Actuary";
    cardTypeName["employer"] = "Employer";
    cardTypeName["inHouseAdmin"] = "In House Administrator";
    cardTypeName["insurer"] = "Insurer";
    cardTypeName["thirdParty"] = "Third Party";
    cardTypeName["trustee"] = "Trustee";
    cardTypeName["corporateGroup"] = "Corporate Group Trustee";
    cardTypeName["independent"] = "Professional / Independent Trustee";
})(cardTypeName || (cardTypeName = {}));
export var defaultEmailErrorMessages = {
    empty: 'Email cannot be empty',
    invalid: 'Invalid email format',
};
export var defaultPhoneErrorMessages = {
    empty: 'Phone number cannot be empty',
    invalid: 'Enter a telephone number, like 0163 960 598 or +44 7700 900 359',
};
//# sourceMappingURL=interfaces.js.map